import { HttpResponse } from '~lib/http/http.response';
import { CustomError } from '~models';

export class HttpError extends CustomError {
    public response: HttpResponse;
    public body?: any;
    public reason: string;

    public constructor(response: HttpResponse,
        body: string) {
        const reason = `${response.status} ${response.statusText}`;

        super(`${response.request.method} ${response.request.url} failed: ${reason}`);

        this.response = response;
        try {
            this.body = JSON.parse(body);
        } catch {
            this.body = body;
        }
        this.reason = reason;

        Object.setPrototypeOf(this, HttpError.prototype);
    }

}
